module.exports = __webpack_public_path__ + "static/media/portfolio-img2.178ffa23.jpg";